import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Loader from '../../../../components/loader';
import LoaderButton from '../../../../components/loaderButton';
import history from '../../../../history';
import { PaymentMode } from '../../../../core/types';

export interface ApplyFinanceOptionProps {
  isChecked: boolean;
  productPackage: any;
  setPaymentOption: (option: PaymentMode) => void;
  total: any;
}

function ApplyFinanceOption({
  isChecked,
  productPackage,
  setPaymentOption,
  total
}: ApplyFinanceOptionProps) {

  const [monthlyPayment84Months, setMonthlyPayment84Months] = useState(0);
  const [monthlyPayment48Months, setMonthlyPayment48Months] = useState(0);
  const [isLoading, setIsLoading] = useState(true)

  const refiDetails = productPackage?.refiDetails;

  const handleContainerClick = () => {
    setPaymentOption('refinance');
  };

  const handleApplyClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    history.push(
      `/refiApp/financing/apply/ownership?package_id=${productPackage.id}&organization_id=${productPackage?.organization?.id}`
    );
  };

  useEffect(() => {
    const principal = total;
    const rate = 0.07 / 12;

    const denominator48 = 1 - Math.pow(1 + rate, -48);
    const denominator84 = 1 - Math.pow(1 + rate, -84);

    const emi48 = (principal * rate) / denominator48;
    const emi84 = (principal * rate) / denominator84;

    setMonthlyPayment48Months(Math.round(emi48));
    setMonthlyPayment84Months(Math.round(emi84));
  }, [total]);

  return (
    <div
      className={classnames('refi-payment-options__container', {
        'refi-payment-options__container--selected': isChecked,
      })}
      onClick={handleContainerClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="refi-payment-options__title-container">
        <span className="refi-payment-options__title">
          Apply For ReFinancing
        </span>

        <div className="refi-payment-options__title-left-section">
            {refiDetails ? (
                <div style={{display: "flex"}}>
                    <div style={{ fontSize: '12px', fontWeight: "10px", color: '#666', lineHeight: '1.4', marginRight: "10px"}}>
                        <div>Applied: {new Date(refiDetails.created_at).toLocaleDateString('en-US', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric'
                            })} - {new Date(refiDetails.created_at).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                            })}
                        </div>
                        <div>Loan Application ID: {refiDetails.loan_application_no}</div>
                    </div>
                    <div>
                        <strong>Status:</strong> {refiDetails.status}
                    </div>
                </div>
            ) : (
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{ marginRight: "10px" }}>
                        { Number.isNaN(Number(monthlyPayment48Months)) && Number.isNaN(Number(monthlyPayment84Months)) ?
                            (<Loader isLoading={isLoading} black={true} className="loader--button" />):
                            <strong>
                                Estimated ${monthlyPayment48Months} to ${monthlyPayment84Months} per month
                                <br />
                                for 48 to 84 months
                            </strong>
                       }
                    </div>

                    <LoaderButton
                        type="button"
                        className="button button-drive-america continue-application-drive-america"
                        style={{width: "30%"}}
                        onClick={handleApplyClick}
                    >
                        Apply
                    </LoaderButton>
                </div>
            )}
        </div>

      </div>
    </div>
  );
}

export default ApplyFinanceOption;
